// extracted by mini-css-extract-plugin
module.exports = {"container":"CCSpinnerPage__container___36Xqv","text":"CCSpinnerPage__text___1_30o"};